import styled from 'styled-components'
import Grid from '@mui/material/Grid'
import Table from '@mui/material/Table'
import TableBody from '@mui/material/TableBody'
import TableCell from '@mui/material/TableCell'
import TableHead from '@mui/material/TableHead'
import TableRow from '@mui/material/TableRow'

export const GoalHeader = styled.h1`
  font-family: 'Roboto', sans-serif;
  font-size: 24px;
  font-weight: 800;
`

export const IntroText = styled.div`
  font-family: 'Roboto', sans-serif;
  padding-bottom: 20px;
  line-height: 1.6;
`

export const StyledGrid = styled(Grid)``

export const StyledTable = styled(Table)``

export const StyledTableBody = styled(TableBody)``

export const StyledTableCell = styled(TableCell)``

export const StyledTableHead = styled(TableHead)``

export const StyledTableRow = styled(TableRow)``
